
import { Component, Prop, Vue } from 'vue-property-decorator';

export type RequirementStatus = 'pristine' | 'met' | 'failed';

@Component
export default class PasswordRequirement extends Vue {
  @Prop({ default: '' }) label!: string;
  @Prop({ default: 'pristine' }) status!: RequirementStatus;
  @Prop({ default: true }) withIcon!: boolean;
  @Prop({ default: false }) small!: boolean;

  @Prop({ default: undefined }) met!: boolean | undefined;

  get computedStatus(): RequirementStatus {
    if (this.met === undefined) {
      return this.status;
    }
    return this.met ? 'met' : 'pristine';
  }

  get iconClass(): string {
    switch (this.computedStatus) {
      case 'met':
        return 'fas fa-check-circle';
      case 'failed':
        return 'fas fa-times-circle';
      default:
        return 'far fa-circle';
    }
  }
}
